export enum TokenStorageKeys {
  AUTH_TOKEN = 'authToken',
  REFRESH_TOKEN = 'refreshToken',
  AUTHENTICATED_USER = 'authenticatedUser',
}
